import React from "react";
import serviceDescImage from "../../assets/service-desc-image.png"; // Replace with your actual image path

const ServiceDescriptionFull = () => {
  return (
    <div className="px-6 md:px-12">
      <div className="w-full md:py-12">
        {/* About Us Content */}
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-evenly items-start space-x-4">
        <div className="md:w-3/5 md:mb-8 md:mb-0 text-justify">
            <p className="md:text-md md:leading-normal md:mb-10 text-sm leading-6">
              Our core competency lies in our sound knowledge of the regulatory
              environment, government policies and procedures, and the role of
              the different government agencies.
              <br />
              <br /> Our further strength is in the experience working on the
              solutions at the ground level, and thus possessing practical
              knowledge, that helps in getting the things done, rather than just
              advising or preparing reports.
              <br />
              <br /> We therefore are able to assess the specific needs of the
              client and identify customized solutions that maximize returns.
              Our well-trained and motivated team always goes that extra mile to
              offer personalized service that is of the highest quality, well
              informed and often implemented under tight delivery schedules.
            </p>
          </div>
          {/* Right Side: Image */}
          <div className="md:w-2/5 sr-only md:not-sr-only">
            <img
              src={serviceDescImage}
              alt="About Us"
              className="float-right max-h-80 rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
      <div>
        <br className="md:hidden"/>
        <p className="md:text-md md:leading-normal mb-10 text-sm text-justify leading-6 md:px-10">
          We offer complete consultancy for Customs and procedure in Bangalore /
          Chennai / Mumbai / Delhi India. This includes advising, preparing,
          submission and obtaining the following benefits from the concerned
          regional licensing authorities:
        </p>
      </div>
    </div>
  );
};

export default ServiceDescriptionFull;
